import { createReducer } from 'typesafe-actions';
import { CANCEL, OK, SHOW_ALERT, SHOW_CONFIRM } from './action-types.js';
import type { ConfirmActionType } from './actions.js';
import type { NAME } from './constants.js';
import type { ShowConfirmParams } from './types.js';

export type ConfirmState = {
  open: boolean;
  message: string;
  title: string;
  hideCancel: boolean;
  type?: 'delete';
  okLabel?: string;
  cancelLabel?: string;
  confirmText?: string;
};

export type ConfirmSlice = {
  [NAME]: ConfirmState;
};

const initialState: ConfirmState = {
  open: false,
  message: '',
  title: '',
  hideCancel: false
};

function hide(state: ConfirmState) {
  return {
    ...state,
    open: false
  };
}

export default createReducer<ConfirmState, ConfirmActionType>(initialState, {
  [SHOW_ALERT](_state: ConfirmState, { payload }: { payload: ShowConfirmParams }) {
    return {
      open: true,
      hideCancel: true,
      ...payload
    };
  },
  [SHOW_CONFIRM](_state: ConfirmState, { payload }: { payload: ShowConfirmParams }) {
    return {
      open: true,
      hideCancel: false,
      ...payload
    };
  },
  [CANCEL]: hide,
  [OK]: hide
});
